import { useDispatch, useSelector } from "react-redux";
import { getGroups, getSingleSensor, updateSensor } from "../../Api Methods/Api";
import { Await, useLoaderData, useNavigate } from "react-router-dom";
import Stats2 from "../../components/UI/Stats/Stats2";
import classes from "./sensorEntity.module.css";
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import { MultiSelect } from "primereact/multiselect";
import { Password } from "primereact/password";
import DataManager from "../../hooks/DataManager";
import { SAMPLING_PERIOD_OPTIONS, POLLING_INTERVAL_OPTIONS, POLARITY_OPTIONS, CONNECTION_DAY_OPTIONS } from "../../components/UI/Cards/Automations/VirutalSources/TankSensor/tankSensorOptions";

// TODO: replace these stubs with real API imports when endpoints are ready
// const getSingleSensorEvents = async (_apiData, _sensorID) => ({ success: false, data: [] });


const SensorEntity = () => {
    console.log("called");

    const sensor = useLoaderData();

    console.log(sensor);

    const [localSensor, setLocalSensor] = useState(sensor);
    const companyName = useSelector(state => state.auth.companyName);
    const role = useSelector(state => state.auth.role);
    localStorage.removeItem('DeviceUUID')
    const isAllowed = companyName === "EyeSpyFX" || companyName === "KNOWIO";
    const isCustomerBillingAllowed = companyName === "EyeSpyFX" || companyName === "RE:SURE";
    const [unauthotisedClick, setUnauthorisedClick] = useState(false);

    const dataManager = new DataManager();
    const [sensorEvents, setSensorEvents] = useState([]);
    const [showLoading, setShowLoading] = useState(true);
    const dispatch = useDispatch();
    const [groups, setGroups] = useState([]);
    const token = localStorage?.getItem("token");
    const client = localStorage?.getItem("client");
    const apiData = { token, client };

    const [changeSensorName, setChangeSensorName] = useState(false);
    const [changeSerialNumber, setChangeSerialNumber] = useState(false);
    const [changeOwnedBy, setChangeOwnedBy] = useState(false);
    const [changeBillable, setChangeBillable] = useState(false);
    const [changeBilledTo, setChangeBilledTo] = useState(false);
    const [changeBillingFrequency, setChangeBillingFrequency] = useState(false);
    const [changeDateOfFirstInvoice, setChangeDateOfFirstInvoice] = useState(false);
    const [changeDateOfLastInvoice, setChangeDateOfLastInvoice] = useState(false);
    const [changeCustomerBilledTo, setChangeCustomerBilledTo] = useState(false);
    const [newCustomerBilledToGroupName, setNewCustomerBilledToGroupName] = useState(localSensor.customerBilledToGroupName || "");

    const [sensorName, setSensorName] = useState(localSensor.pinName);
    const [newSerialNumber, setNewSerialNumber] = useState(localSensor.serial || "");
    const [newOwnerGroupName, setNewOwnerGroupName] = useState(localSensor.ownedByGroupName || localSensor.name);
    const [newBilledToGroupName, setNewBilledToGroupName] = useState(localSensor.billedToGroupName || localSensor.name);
    const [newBillingFrequency, setNewBillingFrequency] = useState("");
    const [newDateOfFirstInvoice, setNewDateOfFirstInvoice] = useState("");
    const [newDateOfLastInvoice, setNewDateOfLastInvoice] = useState("");

    const [navigateToLinkedSite, setNavigateToLinkedSite] = useState(false);
    const [navigateToGroup, setNavigateToGroup] = useState(false);

    // Tank sensor advanced settings
    const [changeTankHeight, setChangeTankHeight] = useState(false);
    const [newTankHeight, setNewTankHeight] = useState(null);

    const [changeLogInterval, setChangeLogInterval] = useState(false);
    const [newLogInterval, setNewLogInterval] = useState(null);

    const [changeSamplingPeriod, setChangeSamplingPeriod] = useState(false);
    const [newSamplingPeriod, setNewSamplingPeriod] = useState(null);

    const [changeConnectionTime, setChangeConnectionTime] = useState(false);
    const [newConnectionTime, setNewConnectionTime] = useState(null);

    const [changeConnectionDays, setChangeConnectionDays] = useState(false);
    const [newConnectionDays, setNewConnectionDays] = useState([]);

    const [changeDevicePassword, setChangeDevicePassword] = useState(false);
    const [newDevicePassword, setNewDevicePassword] = useState("");

    const [changeRccQualityScoreFilter, setChangeRccQualityScoreFilter] = useState(false);
    const [newRccQualityScoreFilter, setNewRccQualityScoreFilter] = useState(null);

    const [changeRssiQualityScoreFilter, setChangeRssiQualityScoreFilter] = useState(false);
    const [newRssiQualityScoreFilter, setNewRssiQualityScoreFilter] = useState(null);

    const [changePollingInterval, setChangePollingInterval] = useState(false);
    const [newPollingInterval, setNewPollingInterval] = useState(null);

    const [editingStaticAlarmIndex, setEditingStaticAlarmIndex] = useState(null);
    const [workingStaticAlarm, setWorkingStaticAlarm] = useState({ polarity: null, threshold: null, hysteresis: null });

    const [editingDynamicAlarmIndex, setEditingDynamicAlarmIndex] = useState(null);
    const [workingDynamicAlarm, setWorkingDynamicAlarm] = useState({ polarity: null, rateOfChange: null });

    const billingOptions = ["Monthly", "Annually"];

    const toast = useRef(null);
    const navigate = useNavigate();

    const GetGroups = async () => {
        const data = await getGroups(apiData, dispatch);
        setGroups(data);
    };

    // const GetSensorEvents = async () => {
    //     const response = await getSingleSensorEvents(apiData, localSensor.deviceID);
    //     if (response.success) {
    //         setSensorEvents(response.data);
    //     }
    //     setShowLoading(false);
    // };

    const convertSensorType = (sensorType) => {
        switch (sensorType) {
            case 7: {
                return "BLE Sensor"
            }
            case 8: {
                return "Standalone NB-IoT Sensor"
            }
        }
    }

    useEffect(() => {
        //GetSensorEvents();
        GetGroups();
    }, []);

    useEffect(() => {
        if (navigateToLinkedSite) {
            navigate(`/Dashboard/SiteView/${localSensor.uuid}`);
        }
    }, [navigateToLinkedSite]);

    useEffect(() => {
        if (navigateToGroup) {
            const groupClicked = groups.find(g => g.name === localSensor.name);
            if (groupClicked) {
                sessionStorage.setItem("groupClicked", groupClicked.name);
                sessionStorage.setItem("groupPath", groupClicked.group_path);
                sessionStorage.setItem("groupClickedID", groupClicked.id);
                navigate("/Dashboard/Groups/GroupSites/");
            }
        }
    }, [navigateToGroup]);

    useEffect(() => {
        if (unauthotisedClick) {
            toast.current.show({
                severity: "error",
                summary: "Unauthorised",
                detail: "Please contact your administrator to update billing for this sensor",
                life: 3000,
            });
            setUnauthorisedClick(false);
        }
    }, [unauthotisedClick]);

    const UpdateSensorDetails = async (columnName, newValue) => {
        const body = {
            sensorID: localSensor.sensorID,
            columnName,
            newValue,
        };
        console.log(body);
        const response = await updateSensor(apiData, body, dispatch);
        if (response.success) {
            setLocalSensor(prev => ({ ...prev, [columnName]: newValue }));
        }
    };

    // Billable confirm / reject
    const accept = async () => {
        UpdateSensorDetails("billable", localSensor.billable == 1 ? 0 : 1);
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Billing status updated", life: 3000 });
    };
    const reject = () => {
        toast.current.show({ severity: "warn", summary: "Cancelled", detail: "Changes discarded", life: 3000 });
    };
    const defaultConfirmProps = {
        header: "Confirmation",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Yes",
        rejectLabel: "No",
        defaultFocus: "accept",
        accept,
        reject,
    };

    const updateSensorName = async () => {
        UpdateSensorDetails("pinName", sensorName);
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Sensor name updated", life: 3000 });
        setChangeSensorName(false);
    };

    const updateSerialNumber = async () => {
        UpdateSensorDetails("name", newSerialNumber);
        setLocalSensor(prev => ({ ...prev, serial: newSerialNumber }));
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Serial number updated", life: 3000 });
        setChangeSerialNumber(false);
    };

    const updateOwnedBy = async () => {
        const newOwnerID = groups.find(g => g.name === newOwnerGroupName)?.id;
        if (!newOwnerID) return;
        UpdateSensorDetails("ownedByGID", newOwnerID);
        setLocalSensor(prev => ({ ...prev, ownedByGroupName: newOwnerGroupName }));
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Owner updated", life: 3000 });
        setChangeOwnedBy(false);
    };

    const updateBilledTo = async () => {
        const newBilledToID = groups.find(g => g.name === newBilledToGroupName)?.id;
        if (!newBilledToID) return;
        UpdateSensorDetails("billedToGID", newBilledToID);
        setLocalSensor(prev => ({ ...prev, billedToGroupName: newBilledToGroupName }));
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Subscription updated", life: 3000 });
        setChangeBilledTo(false);
    };

    const updateCustomerBilledTo = async () => {
        const newCustomerBilledToID = groups.find(g => g.name === newCustomerBilledToGroupName)?.id;
        if (!newCustomerBilledToID) return;
        UpdateSensorDetails("customerBilledToGID", newCustomerBilledToID);
        setLocalSensor(prev => ({ ...prev, customerBilledToGroupName: newCustomerBilledToGroupName, customerBilledToGID: newCustomerBilledToID }));
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Customer billed to updated", life: 3000 });
        setChangeCustomerBilledTo(false);
    };

    const updateBillingFrequency = async () => {
        UpdateSensorDetails("billingFrequency", newBillingFrequency.toLowerCase());
        setLocalSensor(prev => ({ ...prev, billingFrequency: newBillingFrequency }));
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Billing frequency updated", life: 3000 });
        setChangeBillingFrequency(false);
    };

    const updateDateOfFirstInvoice = async () => {
        const formattedDate = newDateOfFirstInvoice ? format(newDateOfFirstInvoice, "yyyy-MM-dd") : "";
        UpdateSensorDetails("firstInvoiceDate", formattedDate);
        setLocalSensor(prev => ({ ...prev, firstInvoiceDate: formattedDate }));
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Invoice date updated", life: 3000 });
        setChangeDateOfFirstInvoice(false);
    };

    const updateDateOfLastInvoice = async () => {
        const formattedDate = newDateOfLastInvoice ? format(newDateOfLastInvoice, "yyyy-MM-dd") : "";
        UpdateSensorDetails("lastInvoiceDate", formattedDate);
        setLocalSensor(prev => ({ ...prev, lastInvoiceDate: formattedDate }));
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Invoice date updated", life: 3000 });
        setChangeDateOfLastInvoice(false);
    };

    // Tank sensor advanced settings - open handlers (seed the working value from the latest saved state)
    const openChangeTankHeight = () => {
        setNewTankHeight(localSensor.tankHeight ?? null);
        setChangeTankHeight(true);
    };

    const openChangeLogInterval = () => {
        setNewLogInterval(localSensor.logInterval ?? null);
        setChangeLogInterval(true);
    };

    const openChangeSamplingPeriod = () => {
        setNewSamplingPeriod(localSensor.samplingPeriod ?? null);
        setChangeSamplingPeriod(true);
    };

    const openChangeConnectionTime = () => {
        if (localSensor.connectionTime) {
            const [hours, minutes] = localSensor.connectionTime.split(":").map(Number);
            const time = new Date();
            time.setUTCHours(hours, minutes, 0, 0);
            setNewConnectionTime(time);
        } else {
            setNewConnectionTime(null);
        }
        setChangeConnectionTime(true);
    };

    const openChangeConnectionDays = () => {
        setNewConnectionDays(localSensor.connectionDays ? localSensor.connectionDays.split(",") : []);
        setChangeConnectionDays(true);
    };

    const openChangeDevicePassword = () => {
        setNewDevicePassword("");
        setChangeDevicePassword(true);
    };

    const openChangeRccQualityScoreFilter = () => {
        setNewRccQualityScoreFilter(localSensor.rccQualityScoreFilter ?? null);
        setChangeRccQualityScoreFilter(true);
    };

    const openChangeRssiQualityScoreFilter = () => {
        setNewRssiQualityScoreFilter(localSensor.rssiQualityScoreFilter ?? null);
        setChangeRssiQualityScoreFilter(true);
    };

    const openChangePollingInterval = () => {
        setNewPollingInterval(localSensor.pollingInterval ?? null);
        setChangePollingInterval(true);
    };

    const openEditStaticAlarm = (index) => {
        setWorkingStaticAlarm(localSensor.staticAlarms[index]);
        setEditingStaticAlarmIndex(index);
    };

    const openEditDynamicAlarm = (index) => {
        setWorkingDynamicAlarm(localSensor.dynamicAlarms[index]);
        setEditingDynamicAlarmIndex(index);
    };

    // Tank sensor advanced settings - save handlers
    const updateTankHeight = async () => {
        UpdateSensorDetails("tankHeight", newTankHeight);
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Tank height updated", life: 3000 });
        setChangeTankHeight(false);
    };

    const updateLogInterval = async () => {
        UpdateSensorDetails("logInterval", newLogInterval);
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Log interval updated", life: 3000 });
        setChangeLogInterval(false);
    };

    const updateSamplingPeriod = async () => {
        UpdateSensorDetails("samplingPeriod", newSamplingPeriod);
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Sampling period updated", life: 3000 });
        setChangeSamplingPeriod(false);
    };

    const updateConnectionTime = async () => {
        const formatted = newConnectionTime ? `${String(newConnectionTime.getUTCHours()).padStart(2, "0")}:${String(newConnectionTime.getUTCMinutes()).padStart(2, "0")}` : null;
        UpdateSensorDetails("connectionTime", formatted);
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "First connection time updated", life: 3000 });
        setChangeConnectionTime(false);
    };

    const updateConnectionDays = async () => {
        const formatted = newConnectionDays.length > 0 ? newConnectionDays.join(",") : null;
        UpdateSensorDetails("connectionDays", formatted);
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Connection days updated", life: 3000 });
        setChangeConnectionDays(false);
    };

    const updateDevicePassword = async () => {
        UpdateSensorDetails("devicePassword", newDevicePassword);
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Device password updated", life: 3000 });
        setChangeDevicePassword(false);
    };

    const updateRccQualityScoreFilter = async () => {
        UpdateSensorDetails("rccQualityScoreFilter", newRccQualityScoreFilter);
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "RCC quality score filter updated", life: 3000 });
        setChangeRccQualityScoreFilter(false);
    };

    const updateRssiQualityScoreFilter = async () => {
        UpdateSensorDetails("rssiQualityScoreFilter", newRssiQualityScoreFilter);
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "RSSI quality score filter updated", life: 3000 });
        setChangeRssiQualityScoreFilter(false);
    };

    const updatePollingInterval = async () => {
        UpdateSensorDetails("pollingInterval", newPollingInterval);
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Polling interval updated", life: 3000 });
        setChangePollingInterval(false);
    };

    const updateStaticAlarm = async () => {
        const updatedAlarms = (localSensor.staticAlarms || []).map((alarm, i) => i === editingStaticAlarmIndex ? workingStaticAlarm : alarm);
        UpdateSensorDetails("staticAlarms", updatedAlarms);
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Threshold alarm updated", life: 3000 });
        setEditingStaticAlarmIndex(null);
    };

    const updateDynamicAlarm = async () => {
        const updatedAlarms = (localSensor.dynamicAlarms || []).map((alarm, i) => i === editingDynamicAlarmIndex ? workingDynamicAlarm : alarm);
        UpdateSensorDetails("dynamicAlarms", updatedAlarms);
        toast.current.show({ severity: "success", summary: "Confirmed", detail: "Rate of change alarm updated", life: 3000 });
        setEditingDynamicAlarmIndex(null);
    };

    const polarityLabel = (polarity) => POLARITY_OPTIONS.find(o => o.value === polarity)?.label || "Not set";
    const samplingPeriodLabel = (value) => SAMPLING_PERIOD_OPTIONS.find(o => o.value === value)?.label || "Not set";
    const pollingIntervalLabel = (value) => POLLING_INTERVAL_OPTIONS.find(o => o.value === value)?.label || "Not set";
    const connectionDaysLabel = (value) => value ? value.split(",").map(d => CONNECTION_DAY_OPTIONS.find(o => o.value === d)?.label || d).join(", ") : "Not set";

    const sensorTypeLabel = (type) => {
        switch (type) {
            case "SIGFOX RE:SURE": return "SigFox lite contact";
            case "IOTA": return "SigFox industrial contact";
            case 7: return "Standalone NB-IOT Sensor";
            case 8: return "BLE Sensor";
            case 10: return "Tank Sensor";
            default: return type || "Unknown";
        }
    };

    const convertGroupIDToName = (groupID) => {
        let group = groups.find(group => group.id == groupID)
        let groupName = ""
        if (group){
            groupName = group.name
        }
        return groupName
    }
    

    ///to get sensor events use userID 2582 and join devices to match up sensorID to event UUID

    return (
        <>
            <Toast ref={toast} />

            {/* ── Sensor name ── */}
            <Dialog
                header="Set sensor name"
                visible={changeSensorName}
                style={{ width: "50vw" }}
                onHide={() => setChangeSensorName(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <InputText
                        value={sensorName}
                        onChange={e => setSensorName(e.target.value)}
                        style={{ width: "100%", fontSize: "1rem" }}
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeSensorName(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateSensorName} />
                    </div>
                </div>
            </Dialog>

            {/* ── Serial number ── */}
            <Dialog
                header="Set serial number"
                visible={changeSerialNumber}
                style={{ width: "50vw" }}
                onHide={() => setChangeSerialNumber(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <InputText
                        value={newSerialNumber}
                        onChange={e => setNewSerialNumber(e.target.value)}
                        style={{ width: "100%", fontSize: "1rem" }}
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeSerialNumber(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateSerialNumber} />
                    </div>
                </div>
            </Dialog>

            {/* ── Billable confirm ── */}
            <ConfirmDialog
                visible={changeBillable}
                onHide={() => setChangeBillable(false)}
                {...defaultConfirmProps}
                message={`Are you sure you want to ${localSensor.billable == 0 ? "start" : "stop"} billing for this sensor?`}
            />

            {/* ── Owned by ── */}
            <Dialog
                header="Select new owner"
                visible={changeOwnedBy}
                style={{ width: "50vw", height: "20vw" }}
                onHide={() => setChangeOwnedBy(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Dropdown
                        placeholder={newOwnerGroupName}
                        options={groups.map(g => g.name).sort((a, b) => a.localeCompare(b))}
                        onChange={e => setNewOwnerGroupName(e.value)}
                        appendTo="self"
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeOwnedBy(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateOwnedBy} />
                    </div>
                </div>
            </Dialog>

            {/* ── Billed to ── */}
            <Dialog
                header="Select new purchasee"
                visible={changeBilledTo}
                style={{ width: "50vw", height: "20vw" }}
                onHide={() => setChangeBilledTo(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Dropdown
                        placeholder={newBilledToGroupName}
                        options={groups.map(g => g.name).sort((a, b) => a.localeCompare(b))}
                        onChange={e => setNewBilledToGroupName(e.value)}
                        appendTo="self"
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeBilledTo(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateBilledTo} />
                    </div>
                </div>
            </Dialog>

            {/* ── Customer billed to ── */}
            <Dialog
                header="Select customer billed to"
                visible={changeCustomerBilledTo}
                style={{ width: "50vw", height: "20vw" }}
                onHide={() => setChangeCustomerBilledTo(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Dropdown
                        placeholder={newCustomerBilledToGroupName || "Select group"}
                        options={groups.map(g => g.name).sort((a, b) => a.localeCompare(b))}
                        onChange={e => setNewCustomerBilledToGroupName(e.value)}
                        appendTo="self"
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeCustomerBilledTo(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateCustomerBilledTo} />
                    </div>
                </div>
            </Dialog>

            {/* ── Billing frequency ── */}
            <Dialog
                header="Select new billing frequency"
                visible={changeBillingFrequency}
                style={{ width: "30vw", height: "20vw" }}
                onHide={() => setChangeBillingFrequency(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Dropdown
                        placeholder={newBillingFrequency}
                        options={billingOptions}
                        onChange={e => setNewBillingFrequency(e.value)}
                    />
                </div>
                <br />
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                    <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeBillingFrequency(false)} className="p-button-secondary" />
                    <Button icon="pi pi-save" label="Save" onClick={updateBillingFrequency} />
                </div>
            </Dialog>

            {/* ── Tank height ── */}
            <Dialog
                header="Set tank height"
                visible={changeTankHeight}
                style={{ width: "30vw" }}
                onHide={() => setChangeTankHeight(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <InputNumber value={newTankHeight} onValueChange={e => setNewTankHeight(e.value ?? null)} min={0} suffix=" cm" style={{ width: "100%" }} inputStyle={{ width: "100%" }} />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeTankHeight(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateTankHeight} />
                    </div>
                </div>
            </Dialog>

            {/* ── Log interval ── */}
            <Dialog
                header="Set log interval"
                visible={changeLogInterval}
                style={{ width: "30vw" }}
                onHide={() => setChangeLogInterval(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <InputNumber value={newLogInterval} onValueChange={e => setNewLogInterval(e.value ?? null)} min={1} suffix=" min" style={{ width: "100%" }} inputStyle={{ width: "100%" }} />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeLogInterval(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateLogInterval} />
                    </div>
                </div>
            </Dialog>

            {/* ── Sampling period ── */}
            <Dialog
                header="Set sampling period"
                visible={changeSamplingPeriod}
                style={{ width: "30vw" }}
                onHide={() => setChangeSamplingPeriod(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Dropdown value={newSamplingPeriod} options={SAMPLING_PERIOD_OPTIONS} onChange={e => setNewSamplingPeriod(e.value)} placeholder="Select sampling period" style={{ width: "100%" }} appendTo="self" />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeSamplingPeriod(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateSamplingPeriod} />
                    </div>
                </div>
            </Dialog>

            {/* ── First connection time ── */}
            <Dialog
                header="Set first connection time (UTC)"
                visible={changeConnectionTime}
                style={{ width: "30vw" }}
                onHide={() => setChangeConnectionTime(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Calendar value={newConnectionTime} onChange={e => setNewConnectionTime(e.value ?? null)} timeOnly />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeConnectionTime(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateConnectionTime} />
                    </div>
                </div>
            </Dialog>

            {/* ── Connection days ── */}
            <Dialog
                header="Set connection days"
                visible={changeConnectionDays}
                style={{ width: "30vw" }}
                onHide={() => setChangeConnectionDays(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <MultiSelect value={newConnectionDays} options={CONNECTION_DAY_OPTIONS} onChange={e => setNewConnectionDays(e.value)} display="chip" placeholder="Select days" style={{ width: "100%" }} appendTo="self" />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeConnectionDays(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateConnectionDays} />
                    </div>
                </div>
            </Dialog>

            {/* ── Device password ── */}
            <Dialog
                header="Set device password"
                visible={changeDevicePassword}
                style={{ width: "30vw" }}
                onHide={() => setChangeDevicePassword(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Password value={newDevicePassword} onChange={e => setNewDevicePassword(e.target.value)} feedback={false} toggleMask style={{ width: "100%" }} inputStyle={{ width: "100%" }} />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeDevicePassword(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateDevicePassword} disabled={!newDevicePassword} />
                    </div>
                </div>
            </Dialog>

            {/* ── RCC quality score filter ── */}
            <Dialog
                header="Set RCC quality score filter"
                visible={changeRccQualityScoreFilter}
                style={{ width: "30vw" }}
                onHide={() => setChangeRccQualityScoreFilter(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <InputNumber value={newRccQualityScoreFilter} onValueChange={e => setNewRccQualityScoreFilter(e.value ?? null)} min={1} max={10} style={{ width: "100%" }} inputStyle={{ width: "100%" }} />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeRccQualityScoreFilter(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateRccQualityScoreFilter} />
                    </div>
                </div>
            </Dialog>

            {/* ── RSSI quality score filter ── */}
            <Dialog
                header="Set RSSI quality score filter"
                visible={changeRssiQualityScoreFilter}
                style={{ width: "30vw" }}
                onHide={() => setChangeRssiQualityScoreFilter(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <InputNumber value={newRssiQualityScoreFilter} onValueChange={e => setNewRssiQualityScoreFilter(e.value ?? null)} min={1} max={10} style={{ width: "100%" }} inputStyle={{ width: "100%" }} />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeRssiQualityScoreFilter(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateRssiQualityScoreFilter} />
                    </div>
                </div>
            </Dialog>

            {/* ── Polling interval ── */}
            <Dialog
                header="Set polling interval"
                visible={changePollingInterval}
                style={{ width: "30vw" }}
                onHide={() => setChangePollingInterval(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Dropdown value={newPollingInterval} options={POLLING_INTERVAL_OPTIONS} onChange={e => setNewPollingInterval(e.value)} placeholder="Select polling interval" style={{ width: "100%" }} appendTo="self" />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangePollingInterval(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updatePollingInterval} />
                    </div>
                </div>
            </Dialog>

            {/* ── Threshold (static) alarm ── */}
            <Dialog
                header={`Edit threshold alarm ${editingStaticAlarmIndex != null ? editingStaticAlarmIndex + 1 : ""}`}
                visible={editingStaticAlarmIndex !== null}
                style={{ width: "30vw" }}
                onHide={() => setEditingStaticAlarmIndex(null)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Dropdown value={workingStaticAlarm.polarity} options={POLARITY_OPTIONS} onChange={e => setWorkingStaticAlarm(prev => ({ ...prev, polarity: e.value }))} placeholder="Polarity" style={{ width: "100%" }} appendTo="self" />
                    <InputNumber value={workingStaticAlarm.threshold} onValueChange={e => setWorkingStaticAlarm(prev => ({ ...prev, threshold: e.value ?? null }))} min={0} suffix=" cm" placeholder="Threshold" style={{ width: "100%" }} inputStyle={{ width: "100%" }} />
                    <InputNumber value={workingStaticAlarm.hysteresis} onValueChange={e => setWorkingStaticAlarm(prev => ({ ...prev, hysteresis: e.value ?? null }))} min={0} suffix=" cm" placeholder="Hysteresis" style={{ width: "100%" }} inputStyle={{ width: "100%" }} />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setEditingStaticAlarmIndex(null)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateStaticAlarm} />
                    </div>
                </div>
            </Dialog>

            {/* ── Rate of change (dynamic) alarm ── */}
            <Dialog
                header={`Edit rate of change alarm ${editingDynamicAlarmIndex != null ? editingDynamicAlarmIndex + 1 : ""}`}
                visible={editingDynamicAlarmIndex !== null}
                style={{ width: "30vw" }}
                onHide={() => setEditingDynamicAlarmIndex(null)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Dropdown value={workingDynamicAlarm.polarity} options={POLARITY_OPTIONS} onChange={e => setWorkingDynamicAlarm(prev => ({ ...prev, polarity: e.value }))} placeholder="Polarity" style={{ width: "100%" }} appendTo="self" />
                    <InputNumber value={workingDynamicAlarm.rateOfChange} onValueChange={e => setWorkingDynamicAlarm(prev => ({ ...prev, rateOfChange: e.value ?? null }))} min={0} suffix=" cm" placeholder="Rate of change" style={{ width: "100%" }} inputStyle={{ width: "100%" }} />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setEditingDynamicAlarmIndex(null)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateDynamicAlarm} />
                    </div>
                </div>
            </Dialog>

            {/* ── Date of hardware invoice ── */}
            <Dialog
                header="Set date of hardware invoice"
                visible={changeDateOfFirstInvoice}
                style={{ width: "30vw" }}
                onHide={() => setChangeDateOfFirstInvoice(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Calendar
                        value={newDateOfFirstInvoice}
                        onChange={e => setNewDateOfFirstInvoice(e.value)}
                        dateFormat="dd mm yy"
                        showIcon
                        inline
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeDateOfFirstInvoice(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateDateOfFirstInvoice} disabled={!newDateOfFirstInvoice} />
                    </div>
                </div>
            </Dialog>

            {/* ── Date of 1st SaaS invoice ── */}
            <Dialog
                header="Set date of 1st SaaS invoice"
                visible={changeDateOfLastInvoice}
                style={{ width: "30vw" }}
                onHide={() => setChangeDateOfLastInvoice(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Calendar
                        value={newDateOfLastInvoice}
                        onChange={e => setNewDateOfLastInvoice(e.value)}
                        dateFormat="dd mm yy"
                        showIcon
                        inline
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeDateOfLastInvoice(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateDateOfLastInvoice} disabled={!newDateOfLastInvoice} />
                    </div>
                </div>
            </Dialog>

            {/* ── Stat tiles ── */}
            <div className={classes.activtyPage_container}>
                <Await resolve={localSensor}>
                    {(loadedSensor) => (
                        <>
                        <div className={classes.container}>
                            <Stats2 title={"Sensor ID"} value={loadedSensor.sensorID} isLoadingStats={false} isStatic={true} />
                            {/* <Stats2 title={"Sensor name"} value={loadedSensor.pinName || "Not set"} isLoadingStats={false} isStatic={true} setChangeGatewayName={setChangeSensorName} editable={role === "admin" || role === "TechSupport"} /> */}
                            <Stats2 title={"Type"} value={sensorTypeLabel(loadedSensor.sensorType)} isLoadingStats={false} isStatic={true} />
                            {/* <Stats2 title={"Serial number"} value={loadedSensor.serial || "Not set"} isLoadingStats={false} isStatic={true} setShowChangeSerialNumber={setChangeSerialNumber} editable={role === "admin" || role === "TechSupport"} /> */}

                            {loadedSensor.uuid && (
                                <Stats2 title={"Linked to"} value={loadedSensor.tag || "Unlinked"} isLoadingStats={false} isStatic={true} setNavigateToLinkedSite={setNavigateToLinkedSite} />
                            )}

                            <Stats2 title={"Battery"} value={loadedSensor.battery && loadedSensor.battery !== "Not Read Yet" ? `${loadedSensor.battery}%` : "No data"} isLoadingStats={false} isStatic={true} />
                            <Stats2 title={"Signal"} value={loadedSensor.signal && loadedSensor.signal !== "Not Read Yet" ? `${loadedSensor.signal}%` : "No data"} isLoadingStats={false} isStatic={true} />

                            {loadedSensor.lastSeen && (
                                <Stats2 title={"Last updated"} value={format(new Date(loadedSensor.lastSeen), "MMM do, yyyy - HH:mm")} isLoadingStats={false} isStatic={true} />
                            )}

                            {loadedSensor.name && (
                                <Stats2 title={"Used by"} value={loadedSensor.name} isLoadingStats={false} isStatic={true} setNavigateToGroup={setNavigateToGroup}  editable={role === "admin" || role === "TechSupport"} />
                            )}

                            {loadedSensor.sensorType === 10 && (
                                <>
                                    {loadedSensor.tankHeight != null && (
                                        <Stats2
                                            title={"Tank height"}
                                            value={`${loadedSensor.tankHeight} cm`}
                                            isLoadingStats={false}
                                            isStatic={true}
                                            setChangeTankHeight={openChangeTankHeight}
                                            editable={role === "admin" || role === "TechSupport"}
                                        />
                                    )}

                                    {loadedSensor.logInterval != null && (
                                        <Stats2
                                            title={"Log interval"}
                                            value={`${loadedSensor.logInterval} min`}
                                            isLoadingStats={false}
                                            isStatic={true}
                                            setChangeLogInterval={openChangeLogInterval}
                                            editable={role === "admin" || role === "TechSupport"}
                                        />
                                    )}

                                    {loadedSensor.samplingPeriod != null && (
                                        <Stats2
                                            title={"Sampling period"}
                                            value={samplingPeriodLabel(loadedSensor.samplingPeriod)}
                                            isLoadingStats={false}
                                            isStatic={true}
                                            setChangeSamplingPeriod={openChangeSamplingPeriod}
                                            editable={role === "admin" || role === "TechSupport"}
                                        />
                                    )}

                                    {loadedSensor.connectionTime && (
                                        <Stats2
                                            title={"First connection time"}
                                            value={`${loadedSensor.connectionTime} UTC`}
                                            isLoadingStats={false}
                                            isStatic={true}
                                            setChangeConnectionTime={openChangeConnectionTime}
                                            editable={role === "admin" || role === "TechSupport"}
                                        />
                                    )}

                                    {loadedSensor.connectionDays && (
                                        <Stats2
                                            title={"Connection days"}
                                            value={connectionDaysLabel(loadedSensor.connectionDays)}
                                            isLoadingStats={false}
                                            isStatic={true}
                                            setChangeConnectionDays={openChangeConnectionDays}
                                            editable={role === "admin" || role === "TechSupport"}
                                        />
                                    )}

                                    {loadedSensor.devicePassword && (
                                        <Stats2
                                            title={"Device password"}
                                            value={"Set"}
                                            isLoadingStats={false}
                                            isStatic={true}
                                            setChangeDevicePassword={openChangeDevicePassword}
                                            editable={role === "admin" || role === "TechSupport"}
                                        />
                                    )}

                                    {loadedSensor.rccQualityScoreFilter != null && (
                                        <Stats2
                                            title={"RCC quality score filter"}
                                            value={loadedSensor.rccQualityScoreFilter}
                                            isLoadingStats={false}
                                            isStatic={true}
                                            setChangeRccQualityScoreFilter={openChangeRccQualityScoreFilter}
                                            editable={role === "admin" || role === "TechSupport"}
                                        />
                                    )}

                                    {loadedSensor.rssiQualityScoreFilter != null && (
                                        <Stats2
                                            title={"RSSI quality score filter"}
                                            value={loadedSensor.rssiQualityScoreFilter}
                                            isLoadingStats={false}
                                            isStatic={true}
                                            setChangeRssiQualityScoreFilter={openChangeRssiQualityScoreFilter}
                                            editable={role === "admin" || role === "TechSupport"}
                                        />
                                    )}

                                    {loadedSensor.pollingInterval != null && (
                                        <Stats2
                                            title={"Polling interval"}
                                            value={pollingIntervalLabel(loadedSensor.pollingInterval)}
                                            isLoadingStats={false}
                                            isStatic={true}
                                            setChangePollingInterval={openChangePollingInterval}
                                            editable={role === "admin" || role === "TechSupport"}
                                        />
                                    )}

                                    {(loadedSensor.staticAlarms || []).map((alarm, index) => (
                                        <Stats2
                                            key={`static-alarm-${index}`}
                                            title={`Threshold alarm ${index + 1}`}
                                            value={`${polarityLabel(alarm.polarity)} ${alarm.threshold ?? "-"}cm (hyst ${alarm.hysteresis ?? "-"}cm)`}
                                            isLoadingStats={false}
                                            isStatic={true}
                                            setChangeStaticAlarm={() => openEditStaticAlarm(index)}
                                            editable={role === "admin" || role === "TechSupport"}
                                        />
                                    ))}

                                    {(loadedSensor.dynamicAlarms || []).map((alarm, index) => (
                                        <Stats2
                                            key={`dynamic-alarm-${index}`}
                                            title={`Rate of change alarm ${index + 1}`}
                                            value={`${polarityLabel(alarm.polarity)} ${alarm.rateOfChange ?? "-"}cm`}
                                            isLoadingStats={false}
                                            isStatic={true}
                                            setChangeDynamicAlarm={() => openEditDynamicAlarm(index)}
                                            editable={role === "admin" || role === "TechSupport"}
                                        />
                                    ))}
                                </>
                            )}

                            <Stats2
                                title={"Owned by"}
                                value={convertGroupIDToName(loadedSensor.ownedByGID) || "Not set"}
                                isLoadingStats={false}
                                isStatic={true}
                                setChangeOwnedBy={setChangeOwnedBy}
                                editable={isAllowed}
                            />

                            {isAllowed && (
                                <Stats2
                                    title={"Billable"}
                                    value={loadedSensor.billable == 1 ? "Yes" : "No"}
                                    isLoadingStats={false}
                                    isStatic={true}
                                    setChangeBillable={setChangeBillable}
                                    isAllowedToChange={isAllowed}
                                    setUnauthorisedClick={setUnauthorisedClick}
                                    editable={true}
                                />
                            )}

                            {(loadedSensor.billable == 1 && isAllowed) && (
                                <Stats2
                                    title={"Inniovate bill to"} //convert to group name!
                                    value={convertGroupIDToName(loadedSensor.billedToGID) || "Not set"}
                                    isLoadingStats={false}
                                    isStatic={true}
                                    setChangeBilledTo={setChangeBilledTo}
                                    isAllowedToChange={isAllowed}
                                    editable={isAllowed}
                                />
                            )}

                            {isAllowed && (
                                <Stats2
                                    title={"Billing frequency"}
                                    value={loadedSensor.billingFrequency ?? "Not set"}
                                    isLoadingStats={false}
                                    isStatic={true}
                                    setChangeBillingFrequency={setChangeBillingFrequency}
                                    isAllowedToChange={isAllowed}
                                    setUnauthorisedClick={setUnauthorisedClick}
                                    editable={true}
                                />
                            )}

                            {isAllowed && (
                                <Stats2
                                    title={"Date of hardware invoice"}
                                    value={loadedSensor.firstInvoiceDate ? format(new Date(loadedSensor.firstInvoiceDate), "dd/MM/yyyy") : "Not set"}
                                    isLoadingStats={false}
                                    isStatic={true}
                                    setChangeDateOfFirstInvoice={setChangeDateOfFirstInvoice}
                                    isAllowedToChange={isAllowed}
                                    setUnauthorisedClick={setUnauthorisedClick}
                                    editable={true}
                                />
                            )}

                            {isAllowed && (
                                <Stats2
                                    title={"Date of 1st SaaS invoice"}
                                    value={loadedSensor.lastInvoiceDate ? format(new Date(loadedSensor.lastInvoiceDate), "dd/MM/yyyy") : "Not set"}
                                    isLoadingStats={false}
                                    isStatic={true}
                                    setChangeDateOfLastInvoice={setChangeDateOfLastInvoice}
                                    isAllowedToChange={isAllowed}
                                    setUnauthorisedClick={setUnauthorisedClick}
                                    editable={true}
                                />
                            )}
                        </div>

                        {isCustomerBillingAllowed && <p style={{marginLeft:"2px", marginTop:"50px", fontWeight:"500", fontSize:"20px", color:"#808080"}}>Customer billing</p>}
                        {isCustomerBillingAllowed && (
                            <div className={classes.container}>
                                <Stats2
                                    title={"RE:SURE bill to"}
                                    value={convertGroupIDToName(loadedSensor.customerBilledToGID) || "No"}
                                    status={""}
                                    isLoadingStats={false}
                                    isStatic={true}
                                    setChangeBilledTo={setChangeCustomerBilledTo}
                                    isAllowedToChange={true}
                                    editable={true}
                                />
                            </div>
                        )}
                        </>
                    )}
                </Await>
            </div>
        </>
    );
};

export default SensorEntity;

export async function sensorLoader({ params }) {
    const sensorID = params.SensorID;
    const token = localStorage?.getItem("token");
    const client = localStorage?.getItem("client");

    const sensor = await getSingleSensor({ token, client }, sensorID);
    console.log(sensor);
    return sensor[0];
}
